import { useCallback, useEffect, useMemo, useState } from 'react';
import { getMonthlyCheckInReserveApi } from '@/api/bodyAndPaint';

interface GetMonthlyCheckInDataHookProp {
  m_plant_id: number;
  year_month: string;
}
export const useGetMonthlyCheckInData = ({
  m_plant_id,
  year_month,
}: GetMonthlyCheckInDataHookProp) => {
  const [checkInDataList, setCheckInDataList] = useState<
    { [date_block: string]: Date[] }[]
  >([]);

  const params = useMemo(() => {
    return {
      m_plant_id,
      year_month,
    };
  }, [m_plant_id, year_month]);

  const fetchData = useCallback(async () => {
    try {
      if (m_plant_id > 0 && year_month !== '') {
        const response = await getMonthlyCheckInReserveApi(params);
        const { enable_datetime_list } = response?.data;
        setCheckInDataList(enable_datetime_list);
      } else {
        setCheckInDataList([]);
        throw { 'invalid parameter': { m_plant_id, year_month } };
      }
    } catch (error) {
      console.error(error);
    }
  }, [params]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { checkInDataList };
};
